export default __webpack_public_path__ + "static/media/logo-us-footlocker.abf2fc36.svg";